export default function HWY_Scroll() {
  this.init = () => {
    scrollToBlock();
  };
  const scrollToBlock = () => {
    jQuery("a").click(function (event) {
      event.preventDefault();
      var href = jQuery(this).attr("href");
      var target = jQuery(this).attr("target");
      if (href.indexOf("#") === -1) {
        if (target) {
          window.open(href, target);
          return;
        }
        window.location.href = href;
        return;
      }
      if (href.replace("#", "")) {
        jQuery(window).width();
        var top = 0;
        if (jQuery(window).width() < 800) {
          top = 30;
        } else {
          top = 50;
        }
        var spacingTop = jQuery("html, body").animate(
          {
            scrollTop: jQuery(href).offset().top - top,
          },
          500
        );
      }
    });
  };
}
